var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.hasTitle ? "form-group row mt-4" : "", "select"] },
    [
      _vm.title
        ? _c("label-control", {
            class: {
              "col-xs-12 col-sm-5 col-form-label": _vm.hasTitle,
              "sr-only": _vm.srLabel
            },
            attrs: {
              title: _vm.title,
              srOnly: _vm.srLabel,
              required: _vm.required,
              forElement: _vm.dropdownId
            }
          })
        : _vm._e(),
      _vm._v(" "),
      this.options
        ? _c(
            "div",
            { class: { "col-xs-12 col-sm-7": _vm.hasTitle } },
            [
              _c("ValidationProvider", {
                ref: "provider",
                attrs: { rules: { required: _vm.required }, slim: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        var failedRules = ref.failedRules
                        return [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputSelectedValue,
                                  expression: "inputSelectedValue"
                                }
                              ],
                              class: _vm.getValidationErrorClasses(failedRules),
                              attrs: {
                                name: _vm.dropdownId,
                                id: _vm.dropdownId,
                                disabled: _vm.savable
                                  ? _vm.isReadOnly || _vm.disabled
                                  : _vm.disabled,
                                "aria-required": _vm.required,
                                "aria-invalid":
                                  _vm.required && errors.length > 0
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.inputSelectedValue = $event.target
                                    .multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              !_vm.omitPlaceholder
                                ? _c(
                                    "option",
                                    {
                                      attrs: { selected: "" },
                                      domProps: { value: null }
                                    },
                                    [_vm._v(_vm._s(_vm.placeholderLabel))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.options, function(option, index) {
                                return _c(
                                  "option",
                                  {
                                    attrs: {
                                      title: _vm.getOptionTitle(option)
                                    },
                                    domProps: {
                                      value: _vm.valueHasNoIdAndNameNotInLocale
                                        ? option.name
                                        : option.id
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "aria-hidden": _vm.doTruncation(
                                            option
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("truncate")(
                                              _vm.getFullDisplayName(option),
                                              _vm.truncateLength
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  938171182
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }